import React, { useMemo, useEffect, useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Home";
import Tech from "./Tech";
import Project from "./Project";
import Contact from "./Contact";
import Scrolltopbutton from "./Scrolltopbutton";
import {debounce} from 'lodash';

function App() {

  const [viewScrollTop, setViewScrollTop] = useState(false);
  
  const handleEndScroll = useMemo(
    ()=>
    debounce(()=>setViewScrollTop(false),2500),             //For making scroll button hidden after 2.5sec
    []
  )

  useEffect(() => {
    const handleScroll = event => {
      (window.pageYOffset <= 400)?setViewScrollTop(false):setViewScrollTop(true);
      handleEndScroll();
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  },[handleEndScroll]);

  return (
    <div className="main" >
      <Home />
      <Tech />
      <Project />
      <Contact/>
      {viewScrollTop&&<Scrolltopbutton />}
      
    </div>
  );
}

export default App;
